import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import NextImage from 'next/image';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';




export const Staircase = styled(Box)`

svg path {fill: #672500}
        ${({ theme: { breakpoints, colors } }) => `
        width: 100%;
        color: ${colors.oranges.orange2};
        flex-direction: column-reverse;
        padding: 30px 0;
     
     
        position: relative;
        h2 {font-size: 24px;}
        p {font-size: 16px;}
        display: flex;

        ${breakpoints.up('md')} {
            h2 {font-size: 39px;}
            p {font-size: 24px;}
            left: 40%;
    
        };


        &::before { 
            content: '';
            position: absolute;
            top: 0;
            right: 0 !important;
            background-color: ${colors.oranges.orange1};
            right: -16px;
            width: 100vw;
            height: 100%;
        
            z-index: -1;
        
        }
        
        &::after { 
            content: '';
            position: absolute;
            top: 0;
            left: 0 !important;
            background-color: ${colors.oranges.orange1};
            right: -16px;
            width: 100vw;
            height: 100%;
        
            z-index: -1;
        
        }


        ${breakpoints.up('md')} {
            &::before { display: none; }

            width: 100%;      
            margin-top: -20px;
            z-index: unset;
            flex-direction: column;
            &::after {
                background-color:  ${colors.oranges.orange1} !important;
            }
        }

        `}
        `

        export const MainContainer = styled(Box)`
${({ theme: { breakpoints } }) => `
 Display: flex; 
 margin-top: 40px;

 ${breakpoints.up('md')} {
    margin-top: unset;
}

 `}
 `
    ;

export const StaircaseContent = styled(Box)`
        ${({ theme: { breakpoints, colors } }) => `

        ${breakpoints.up('md')} {
            color: ${colors.oranges.orange2};
            width: 30%;
            justify-content: center;
            position: relative;
             right: -25%;
             padding: 0;
            margin-top: 20px;
            display: unset;
        };
        background-color: ${colors.oranges.orange1} !important;
        width: 100%;
        margin-top: 125px;
        background-repeat: no-repeat;
        display: flex; 
        flex-direction: column;
        justify-content: center;

        `}`;

        export const StaircasedButton = styled(Button) `
        ${({ theme: { breakpoints, colors } }) => `
   
      
        border: 1px solid ${colors.oranges.orange2};
        color: ${colors.oranges.orange2};
      
        padding: 10px 20px;
        
        box-shadow: -1px 1px 6px  ${colors.oranges.orange2};
        `}   
        `;

        export const StaircaseContainer = styled(Box) `
        ${({ theme: { breakpoints, colors } }) => `
        display: flex;
        flex-direction: column;
        align-items: center;

        ${breakpoints.up('md')} {
            flex-direction: row;
        }

  
        `}
        `;

        // export const WhyChooseValuesContainerOp1 = styled(Box) `
        // ${({ theme: { breakpoints, colors } }) => `
        // margin-bottom: 20px;
        // ${breakpoints.up('md')} {
        // margin-bottom: 0;
        // margin-right: 20px;
        // }
        
        // `}
        // `;

        // export cons WhyChooseValuesContainerOp2 = styled(Box) `
        // ${({ theme: { breakpoints, colors } }) => `
        // `}
        // `;